import { Component, ViewChild } from '@angular/core';
import { AlertController, App, LoadingController, MenuController, NavController, NavParams, Platform } from 'ionic-angular';
import { SearchService } from '../../providers/search';
import { SearchresultsPage } from '../searchresults/searchresults';
import { TranslateCategoryPipe } from '../../shared/translate-category.pipe';
import { TranslateCondidtionsPipe } from '../../shared/translate-conditions.pipe';
import { AppConfig } from '../../shared/app.config';
import { ExtendedSearch } from './extended-search/extended-search';
import { Http } from '@angular/http';
import { ErrorHandling } from '../../shared/error.handling';
import { LastSearch } from '../../model/lastsearch';
import { LastSearchQueryPage } from "../last-search-query/last-search-query";

@Component({
    selector: 'page-search',
    templateUrl: 'search.html'
})
export class SearchPage {

    searchTerm: string = '';
    searchFilter: any = {};
    searchCategory: string;
    searchResults: any[];
    storedSearchCategory: string;
    viewState: any;
    buttonState: boolean = true; //default: false
    useglobalsearch: boolean = false;
    uselastsearchqueries: boolean = false;
    confCategories: any;
    title: any;
    positionSearchbar: any;
    positionFilter: any;
    @ViewChild(ExtendedSearch)
    private extendedSearch: ExtendedSearch;

    /**
     * Constructor.
     * @param navCtrl
     * @param navParams
     * @param searchService
     * @param alertCtrl
     * @param loadingCtrl
     * @param platform
     * @param app
     * @param menuCtrl
     * @param globalConf
     * @param http
     * @param errorHandling
     */
    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public searchService: SearchService,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController,
                public platform: Platform,
                public app: App,
                public menuCtrl: MenuController,
                public globalConf: AppConfig,
                public http: Http,
                public errorHandling: ErrorHandling) {

        this.positionSearchbar = 'center';
        this.positionFilter = 'outside';

        let useglobalsearch = localStorage.getItem('useglobalsearch'); //Experimental feature

        if (useglobalsearch) {
            if (JSON.parse(useglobalsearch) == '0') {
                this.useglobalsearch = false;
            } else if (JSON.parse(useglobalsearch) == '1') {
                this.useglobalsearch = true;
            }
        }

        let uselastsearchqueries = localStorage.getItem('uselastsearchqueries');

        if (uselastsearchqueries) {
            if (JSON.parse(uselastsearchqueries) == '0') {
                this.uselastsearchqueries = false;
            } else if (JSON.parse(uselastsearchqueries) == '1') {
                this.uselastsearchqueries = true;
            }
        }

        this.searchCategory = this.navParams.get('selectedSearchCategory');
        this.viewState = 'init';
        this.buttonState = true; //default: false;
        this.menuCtrl.swipeEnable(false);
        this.menuCtrl.enable(true);
    }

    /**
     * Loads cached categories
     */
    ionViewDidLoad() {
        let conditionsApp: any = {
            categories: []
        };

        let response: any;
        response = this.globalConf.getCachedCategories();
        if (response) {
            let appStructs: any = response.AppStructs;
            let translateConditionsPipe = new TranslateCondidtionsPipe();

            Object.keys(appStructs).forEach(function (key, index) {
                let categoryString = translateConditionsPipe.transform(appStructs[key]);
                let iconString = translateConditionsPipe.seticon(appStructs[key]);

                if (appStructs[key] != '') {
                    conditionsApp.categories.push({
                        "name": categoryString,
                        "icon": iconString
                    })
                }
            });

            this.confCategories = conditionsApp.categories;
            localStorage.setItem('categories', JSON.stringify(conditionsApp));

            setTimeout(() => {
                this.setActiveCategory();
            }, 250);
        } else {
            this.errorHandling.handle(response, 'Search - getCategories return null');
        }
    }

    /** Sets the current category as active in localStorage */
    setActiveCategory() {
        this.searchCategory = this.navParams.get('selectedSearchCategory');

        if (typeof this.searchCategory === 'undefined') {
            this.searchCategory = localStorage.getItem('storedSearchCategory') || 'Structure';
        }
    }

    /** Sets view state as touched */
    setTouched() {
        this.viewState = 'touched';
    }

    /**
     * Change search category
     * @param cat
     */
    changeCategory(cat) {
        this.searchCategory = cat;
        this.title = 'Suche ';
        switch (cat) {
            case 'Structure':
                this.title += 'Aktenzeichen';
                break;
            case 'Folder':
                this.title += 'Teilakten/Vorgänge';
                break;
            case 'Document':
                this.title += 'Schriftstücke';
                break;
            case 'Address':
                this.title += 'Adressen';
                break;
            case 'Meeting':
                this.title += 'Sitzungen';
                break;
            case 'Global':
                this.title += 'Übergreifend';
                break;
        }
        this.app.setTitle(this.title);
        localStorage.setItem('storedSearchCategory', cat);
    }

    /** Starts the search */
    startSearch() {
        let emptySearchObject = this.isEmptySearchObj(this.searchFilter[this.searchCategory]);

        if (!emptySearchObject || this.searchTerm.length > 2) {
            this.startSearchAPI();
        } else {
            let alert = this.alertCtrl.create({
                title: 'Ihre Eingabe',
                subTitle: 'Bitte geben Sie mindestens drei Zeichen ein.',
                buttons: ['Ok']
            });

            alert.present();
        }
    }

    /**
     * Evaluates if object is empty or not
     * @param obj
     * @returns {boolean}
     */
    isEmptySearchObj(obj) {
        if (typeof obj === 'object') {
            return Object.keys(obj).every(function (x) {
                return obj[x] === '' || obj[x] === null;
            });
        } else {
            return true;
        }
    }

    /** Sends search request to server */
    startSearchAPI() {
        let loader = this.loadingCtrl.create();
        loader.present();

        this.searchService.search(this.searchTerm, this.searchCategory, this.searchFilter)
            .subscribe(
                (success) => {
                    loader.dismiss();
                    this.searchResults = success.results;

                    if (this.searchResults) {
                        this.navCtrl.push(SearchresultsPage, {
                            'resultList': this.searchResults,
                            'resultTotalCount': success.resultTotalCount,
                            'searchLevel1': success.searchLevel1,
                            'category': this.searchCategory,
                            'searchTerm': this.searchTerm,
                            'searchFilter': this.searchFilter
                        });

                        // Letzte erfolgreiche Suchanfrage speichern
                        this.saveLastSearchQuery(this.searchTerm, this.searchCategory, this.searchFilter);

                    } else {
                        this.presentAlert();
                    }
                },
                (error) => {
                    loader.dismiss();
                    this.errorHandling.handle(error, 'Search');
                }
            );
    }

    /**
     * Saves last search query to localStorage
     * @param term
     * @param cat
     * @param filter
     */
    saveLastSearchQuery(term, cat, filter) {
        let storedSearchQuery: any = JSON.parse(localStorage.getItem('lastsearch'));

        let lastSearch: LastSearch = {
            searchterm: term,
            searchcat: cat,
            searchfilter: filter
        };

        if (storedSearchQuery.length >= 10) {
            storedSearchQuery.shift();
        }

        storedSearchQuery.push(lastSearch);
        localStorage.setItem('lastsearch', JSON.stringify(storedSearchQuery));
    }

    /** Resets search when user confirms the dialog */
    resetSearch() {
        let alert = this.alertCtrl.create({
            title: 'Zurücksetzen',
            message: 'Sollen alle Suchkriterien zurückgesetzt werden?',
            buttons: [
                {
                    text: 'Abbrechen'
                },
                {
                    text: 'Zurücksetzen',
                    handler: () => {
                        this.searchFilter = {};
                        this.searchTerm = '';
                        this.extendedSearch.resetFilter({resetPreviousFilter: true});
                    }
                }
            ]
        });
        alert.present();
    }

    /** Presents alert, that no results were found */
    presentAlert() {
        let translateCategoryPipe = new TranslateCategoryPipe();
        let searchCategoryString = translateCategoryPipe.transform(this.searchCategory);

        let alert = this.alertCtrl.create({
            title: 'Suche ' + searchCategoryString,
            subTitle: 'Keine ' + searchCategoryString + ' gefunden!',
            buttons: ['Ok']
        });
        alert.present();
    }

    /**
     * Saves filter
     * @param event
     */
    saveFilter(event) {
        this.searchFilter = event;
    }

    /**
     * Pushes last search query page view
     */
    goLastSearchQueries() {
        this.navCtrl.push(LastSearchQueryPage);
    }
}




// WEBPACK FOOTER //
// ./src/pages/search/search.ts